import ConsentUtil from '@utils/ConsentUtil';

export default {

    setThemeForUser(user) {
        // Set mode.
        if (user.theme === 'dark') {
            document.documentElement.classList.add('dark-mode');
        } else if (user.theme === 'light') {
            document.documentElement.classList.remove('dark-mode');
        } else {
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                document.documentElement.classList.add('dark-mode');
            } else {
                document.documentElement.classList.remove('dark-mode');
            }
        }
    },

    unsetThemeForUser(user) {
        // Unset dark mode.
        document.documentElement.classList.remove('dark-mode');
        if (user && !user.is_sub_account) {
            // Reset primary color.
            document.documentElement.style.setProperty('--color-primary', '#0064ff');
            // Unset custom styles and scripts.
            let styles = document.getElementById('custom-styles');
            if (styles) {
                document.head.removeChild(styles);
            }
            let scripts = document.getElementById('custom-scripts');
            if (scripts) {
                document.body.removeChild(scripts);
            }
        }
    },

    setThemeForAgency(agency) {
        if (!agency || typeof agency !== 'object' || Array.isArray(agency)) {
            return;
        }

        document.documentElement.style.setProperty(
            '--color-primary',
            agency.color_primary || '#0064ff',
        );

        const customCss = agency.styles != null ? agency.styles : '';
        let styles = document.getElementById('custom-styles');
        if (!styles) {
            styles = document.createElement('style');
            styles.id = 'custom-styles';
            styles.appendChild(document.createTextNode(customCss));
            document.head.appendChild(styles);
        } else {
            styles.textContent = customCss;
        }
        ConsentUtil.onReady('marketing', () => {
            let scripts = document.getElementById('custom-scripts');
            if (!scripts && agency.scripts) {
                scripts = document.createElement('div');
                scripts.style.display = 'none';
                scripts.id = 'custom-scripts';
                scripts.innerHTML = agency.scripts;
                document.body.appendChild(scripts);
                scripts.querySelectorAll('script').forEach(script => {
                    try {
                        eval(script.innerHTML);
                    } catch (error) {
                        console.error('Error executing script:', error);
                    }
                });
            }
        });
    },

    setThemeForProject(project) {
        if (!project || typeof project !== 'object' || Array.isArray(project)) {
            return;
        }

        document.documentElement.style.setProperty(
            '--color-primary',
            project.color_primary || '#0064ff',
        );
    },

}
